import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmX = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "icon-llm-x",
    "data-icon": "icon-llm-x",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      d: "M18 6L6 18M6 6L18 18",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeLinejoin: "round"
    })
  }));
});
IconLlmX.displayName = 'IconLlmX';

export { IconLlmX };
//# sourceMappingURL=llm-x.js.map
